import { FunctionComponent, MutableRefObject, useEffect } from 'react';
import { Spin } from 'antd';
import { createElement, ElementTypes, init } from '@airwallex/components-sdk';
import { useStore } from '@hub/helpers/use-store';
import { IUnitTestProps } from '@monorepo/client-types';
import { LoadingState, useLoading } from '@monorepo/react-hooks';
import { AirwallexAccountAuth } from '@monorepo/types';

interface Props extends IUnitTestProps {
  beneficiaryFormRef: MutableRefObject<
    ElementTypes['beneficiaryForm'] | undefined
  >;
}

const AirwallexWithdraw: FunctionComponent<Props> = ({
  beneficiaryFormRef,
  testId,
}) => {
  const { isLoading, updateLoadingState } = useLoading(LoadingState.Loading);

  const {
    dataStore: { payoutStore },
  } = useStore();

  useEffect(() => {
    const createBeneficiaryForm = async () => {
      try {
        const airwallexKeys: AirwallexAccountAuth =
          await payoutStore.getAirwallexAuth();

        await init({
          env: airwallexKeys.env,
          authCode: airwallexKeys.authCode,
          clientId: airwallexKeys.clientId,
          codeVerifier: airwallexKeys.codeVerifier,
        });

        const beneficiaryForm = await createElement('beneficiaryForm', {
          defaultValues: {
            beneficiary: {
              entity_type: 'PERSONAL',
            },
          },
          customizations: {
            ui: {
              hideFeeConfig: true,
              hideFlightTime: true,
            },
            fields: { 'beneficiary.entity_type': { hidden: true } },
            minHeight: 400,
          },
        });

        beneficiaryForm.mount('#beneficiary-root');
        beneficiaryFormRef.current = beneficiaryForm;
        updateLoadingState(LoadingState.Loaded);
      } catch (e) {
        console.error('Error initializing Airwallex:', e);
        updateLoadingState(LoadingState.Error);
      }
    };

    void createBeneficiaryForm();
  }, [payoutStore]);

  return (
    <div data-testid={testId}>
      {isLoading && <Spin size="large" className="loading-spinner" />}
      <div id="beneficiary-root" />
    </div>
  );
};

export default AirwallexWithdraw;
